import { Component, OnInit } from '@angular/core';
import { Po } from '../po';
import { PoService } from '../po.service';
import { Poitem } from '../poitem';
import { Costcenter } from '../../costcenter/costcenter';
import { CostcenterService } from '../../costcenter/costcenter.service';
import { AuthService } from '../../auth.service';
import { PoListPipe } from '../../pipe/polist.pipe';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
declare var jsPDF: any;

@Component({
  selector: 'app-po-list',
  templateUrl: './po-list.component.html',
  styleUrls: ['./po-list.component.css']
})
export class PoListComponent implements OnInit {

  closeResult: string; 
  page=1;
  SerchText:string ='';

  costcenters: Costcenter[];
  id:number = 0;
	public POItemArray: Array<Poitem> = [];
	

    public POItemChrgArray: Array<Poitem> = [];
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  purchase_order = new Po();  //Po is defined from abobe import po
  purchase_orders: Po[];
  public filter_purchase_orders:any = [];
  submitted = false;
  message: string;	
  public DeletePo = "none"
  public Costcenter = "none"
  public UnApprovePo = "none"
public selectedPoID;
public selectedUnApprovePo;

  poFilter: any = { ponumber: '' };
  totalrecord:number;
  constructor(private poService: PoService,
    private costcenterService: CostcenterService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private modalService: NgbModal,
    public auth: AuthService
    ) { }

    open(content,poid) {
      this.GetPODetails(poid);
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

  
    OpenCostcenter(){
      this.Costcenter='block'; 
     }

    
     closeCostcenter(){
      this.Costcenter='none'; 
    }
    


    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

    public captureScreen() {
      var imgData = 'data:image/png;base64,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';
 
     let doc = new jsPDF('p','pt','letter'); 
 //     let contentToConvert1 = this.contentToConvert1.nativeElement;
 //     let contentToConvert2 = this.contentToConvert2.nativeElement;
 //     let contentToConvert3 = this.contentToConvert3.nativeElement;
     let margins = {top: 10, bottom: 10, left: 5, right: 5};
     doc.addImage(imgData, 'JPEG', 15, 10, 170, 44);
     doc.setFontSize(12);
     doc.setLineWidth(1);
     doc.line(600, 65, 10, 65);
     doc.autoTable({
       startY: 90,
       theme:'plain',
       styles: {fillColor: [255, 255, 255],cellWidth: 'wrap'},
       columnStyles: {4: {halign: 'left', minCellHeight: 20,cellWidth: 'auto', overflow: 'linebreak'},
                      0: {cellWidth: 70, minCellHeight: 30},
                      1: {cellWidth: 150},
                      2: {cellWidth: 'auto'},
                      3: {cellWidth: 90}},
       margin:margins,
       html: '#poinfo'});
  
       doc.autoTable({
         cellPadding:5,
         styles: {valign: 'middle',halign: 'left'},
         columnStyles: {
         0: {cellWidth: 20,minCellHeight: 20,halign: 'left'},
         1: {cellWidth: 70},
         2: {cellWidth: 65},
         3: {cellWidth: 65},
         4: {cellWidth: 35},
         5: {cellWidth: 40},
         6: {cellWidth: 30},
         7: {cellWidth: 65},
         8: {cellWidth: 65},
         9: {cellWidth: 55},
         10: {cellWidth: 70},

       },
       margin:margins,
       html: '#itemtable'});
    
  
       doc.autoTable({
        theme:'plain',
        styles: {fillColor: [255, 255, 255],cellWidth: 'wrap'},
        columnStyles: {0: {halign: 'left', minCellHeight: 20,cellWidth: 'auto', overflow: 'linebreak'}},
        margin:margins,
        html: '#notestable'});


     doc.autoTable({
        theme:'plain',
        styles: {fillColor: [250, 250, 250],cellWidth: 'wrap',valign: 'middle',halign: 'left'},
        columnStyles: {
          0: {cellWidth: 115,minCellHeight: 30,halign: 'left'},
          1: {cellWidth: 150},
          2: {cellWidth: 70},
          3: {cellWidth: 120},
          4: {cellWidth: 70},
          5: {cellWidth: 100},
        },
        margin:margins,
        html: '#daystable'});
  



      doc.autoTable({
        theme:'plain',
        styles: {fillColor: [255, 255, 255],cellWidth: 'wrap'},
        columnStyles: {0: {halign: 'left', minCellHeight: 10,cellWidth: 'auto', overflow: 'linebreak'}},
        margin:{top: 5, bottom: 5, left: 5, right: 5},
        html: '#penaltytable'});
      
      doc.autoTable({
        theme:'plain',
        styles: {fillColor: [250, 250, 250],cellWidth: 'wrap'},
        columnStyles: {0: {halign: 'left', minCellHeight: 20,cellWidth: 'auto', overflow: 'linebreak'}},
        margin:{top: 5, bottom: 5, left: 5, right: 5},
        html: '#remarktable'});

 
       doc.save('PO_'+ (this.purchase_order.ponumber) +'.pdf');
        
     }
  ngOnInit(): void {
    this.spinnerService.show();   
    this.getPos();
    this.getCostCenters()
    /*this.dropdownCostCenterSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    }; */
  }

  onItemSelect(item: any) {
    
  }
  onSelectAll(items: any) {
    
  }
  GetPODetails(poid) {
   // const id = +this.route.snapshot.paramMap.get('poid');
    this.poService.GetPODetails(poid)
      .subscribe(purchase_order => 
	  
	  {
		  this.purchase_order = purchase_order
		  this.POItemArray = this.purchase_order.poitem.filter(items => items.isadditionalcharges == 0);
		 this.POItemChrgArray = this.purchase_order.poitem.filter(items => items.isadditionalcharges == 1);
	  
	  });
  }

  getPos() {
    this.spinnerService.show();    
	
	 if(this.auth.currentUserValue.userroleid == 4){
		 
		 
		    return this.poService.GetUserPurchaseOrder(this.auth.currentUserValue.userid)
               .subscribe(
                purchase_orders => {  
                 
                    this.purchase_orders = purchase_orders
                     this.filter_purchase_orders = purchase_orders;     
                  
                  this.totalrecord = this.purchase_orders.length;
                  this.spinnerService.hide();
                 }
                );
	 }
	  else if(this.auth.currentUserValue.userroleid == 5){
		 
		 
		    return this.poService.GetRequestorPurchaseOrder(this.auth.currentUserValue.userid)
               .subscribe(
                purchase_orders => {  
                 
                    this.purchase_orders = purchase_orders
                     this.filter_purchase_orders = purchase_orders;      
                  this.spinnerService.hide();
                  this.totalrecord = this.purchase_orders.length;
                  
                 }
                );
	 }
	 else
	 {
		    return this.poService.getPos()
               .subscribe(
                purchase_orders => {  
                 
                  this.purchase_orders = purchase_orders;
                  this.filter_purchase_orders = purchase_orders;
                  this.spinnerService.hide();
                  this.totalrecord = this.purchase_orders.length;
       
                 }
                );
	 }
   
   
 }



delete(poid): void {
			this.poService.GetPODetails(poid).subscribe(purchase_order =>
				{
					
					this.purchase_order = purchase_order;
					this.purchase_order.isdeleted =1;
					 this.poService.updatePo(this.purchase_order).subscribe(()=> 
					{
            this.message = "PO Deleted Successfully!";
            this.closeDeletePo();
						 this.getPos();
					});
					
					
				});
  
      
}


  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

OpenDeletePo(poID){
  this.selectedPoID = poID
  this.DeletePo='block'; 
 }

 closeDeletePo(){
  this.DeletePo='none'; 
}

getCostCenters() {
  return this.costcenterService.getCostcenterlist()
             .subscribe(
              costcenters => {
      //          
                this.costcenters = costcenters
                this.costcenters.filter(item => Object.assign(item, {isActive: true}));
      //          
               }
              );
}

public getPolistByCostcenter(){
    var filter_purchase_order = this.filter_purchase_orders;
    this.purchase_orders = filter_purchase_order;
    for(var i= 0; i< this.costcenters.length; i++){
      if(!this.costcenters[i].isActive)
      {
        this.purchase_orders = this.purchase_orders.filter(po => po.costcenterid !== this.costcenters[i].costcenterid)
      }
    
  }
    this.totalrecord = this.purchase_orders.length;
  //  
}


resetAllFilters(){ 
  this.costcenters.filter(item => Object.assign(item, {isActive: true}));
  this.getPolistByCostcenter();
}

OpenUnApprovePo(poID){
  this.selectedUnApprovePo = poID
  this.UnApprovePo='block'; 
 }

 closeUnApprovePo(){
  this.UnApprovePo='none'; 
}


UnApprovePoByID(poID): void {


  this.poService.GetPODetails(poID).subscribe(purchase_order =>
    {
      
      this.purchase_order = purchase_order;
      this.purchase_order.statusid =1;
       this.poService.updatePo(this.purchase_order).subscribe(()=> 
      {
        this.closeUnApprovePo();
         this.getPos();
      });
      
      
    });

  
}


}
